export const URLS = {
  QA: "/",
};
